import { render, staticRenderFns } from "./SystemMessageDialog.vue?vue&type=template&id=f6ea6236&scoped=true"
import script from "./SystemMessageDialog.vue?vue&type=script&lang=js"
export * from "./SystemMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./SystemMessageDialog.vue?vue&type=style&index=0&id=f6ea6236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ea6236",
  null
  
)

export default component.exports